const filterFunction = (value) => (item) =>
  String(item.label).toLowerCase().includes(value.toLowerCase()) ||
  String(item.group).toLowerCase().includes(value.toLowerCase())

export default filterFunction
